var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 310,
    viewBox: "0 0 310 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 155,
    r: 154.733,
    stroke: "black",
    strokeWidth: 0.533333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.556,
    cy: 155,
    r: 120.289,
    stroke: "black",
    strokeWidth: 0.533333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.7222,
    cy: 155,
    r: 94.4556,
    stroke: "black",
    strokeWidth: 0.533333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.067 155C103.067 173.971 97.2992 191.136 87.9872 203.552C78.6752 215.968 65.8313 223.622 51.6667 223.622C37.5021 223.622 24.6581 215.968 15.3461 203.552C6.03415 191.136 0.266667 173.971 0.266667 155C0.266667 136.029 6.03415 118.864 15.3461 106.448C24.6581 94.0325 37.5021 86.378 51.6667 86.378C65.8313 86.378 78.6752 94.0325 87.9872 106.448C97.2992 118.864 103.067 136.029 103.067 155Z",
    stroke: "black",
    strokeWidth: 0.533333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBig);
export default __webpack_public_path__ + "static/media/circle-big.52f6e56b2f63c7a265d4862a6381ca9d.svg";
export { ForwardRef as ReactComponent };